import { access } from "fs";
import { ReactNode } from "react";
import { IconCalendar, IconCollaborator, IconComputer, IconGestion, IconPeopleProjects, IconGear, IconHome, IconInvoice } from "../../../icons";

interface IMOCK {
  module: string;
  icon: ReactNode;
  screens: IScreens[];
}

interface IScreens {
  name: string;
  options: IOptions[];
}

interface IOptions {
  name: string;
  id: number;
  checked: boolean;
}

export enum ACCESS {
  ROUTINE_APPOINTMENT_read = 1,
  ROUTINE_APPOINTMENT_consolidate,
  APPROVAL_HOURS_read_approve,
  APPROVAL_HOURS_notification,
  APPROVAL_HOURS_invoice,
  APPROVAL_HOURS_download,
  HOURS_MANAGEMENT_all,
  USERS_DATA_all,
  USERS_SELF_REGISTRATION_read,
  HISTORY_all,
  CLIENT_all,
  PROJECT_read,
  PROJECT_write,
  TIMESHEET_all,
  IMMOBILIZED_all,
  ELETRONICS_all,
  SETTINGS_all,
  HOMEPAGE_graphic,
  HOMEPAGE_cards,
  SELF_INVOICE_all,
}

export const MOCK: IMOCK[] = [
  {
    module: "Gestão de Horas",
    icon: IconGestion,
    screens: [
      {
        name: "Consolidação de Horas",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.ROUTINE_APPOINTMENT_read,
            checked: false,
          },
          {
            name: "Consolidar",
            id: ACCESS.ROUTINE_APPOINTMENT_consolidate,
            checked: false,
          },
        ],
      },
      {
        name: "Aprovação de Horas",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.APPROVAL_HOURS_read_approve,
            checked: false,
          },
          {
            name: "Notificação",
            id: ACCESS.APPROVAL_HOURS_notification,
            checked: false,
          },
          {
            name: "Nota Fiscal",
            id: ACCESS.APPROVAL_HOURS_invoice,
            checked: false,
          },
          {
            name: "Download",
            id: ACCESS.APPROVAL_HOURS_download,
            checked: false,
          },
        ],
      },
      {
        name: "Banco de Horas",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.HOURS_MANAGEMENT_all,
            checked: false,
          },
        ],
      },
    ],
  },
  {
    module: "Profissionais",
    icon: IconCollaborator,
    screens: [
      {
        name: "Dados Cadastrais",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.USERS_DATA_all,
            checked: false,
          },

          {
            name: "Auto Perfil",
            id: ACCESS.USERS_SELF_REGISTRATION_read,
            checked: false,
          },
        ],
      },
      {
        name: "Histórico",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.HISTORY_all,
            checked: false,
          },
        ],
      },
    ],
  },
  {
    module: "Clientes",
    icon: IconPeopleProjects,
    screens: [
      {
        name: "Dados Cadastrais",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.CLIENT_all,
            checked: false,
          },
        ],
      },
      {
        name: "Projetos",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.PROJECT_read,
            checked: false,
          },

          {
            name: "Criar/Editar",
            id: ACCESS.PROJECT_write,
            checked: false,
          },
        ],
      },
    ],
  },
  {
    module: "Nota Fiscal",
    icon: IconInvoice,
    screens: [
      {
        name: "Nota Fiscal",
        options: [
          {
            name: "Acesso Total",
            id: ACCESS.SELF_INVOICE_all,
            checked: false,
          },
        ],
      },
    ],
  },
  {
    module: "Time Sheet",
    icon: IconCalendar,
    screens: [
      {
        name: "Time Sheet",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.TIMESHEET_all,
            checked: false,
          },
        ],
      },
    ],
  },
  {
    module: "Gestão de Inventário",
    icon: IconComputer,
    screens: [
      {
        name: "Imobilizados",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.IMMOBILIZED_all,
            checked: false,
          },
        ],
      },
      {
        name: "Eletrônicos",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.ELETRONICS_all,
            checked: false,
          },
        ],
      },
    ],
  },
  {
    module: "Configurações",
    icon: IconGear,
    screens: [
      {
        name: "Configurações",
        options: [
          {
            name: "Visualizar",
            id: ACCESS.SETTINGS_all,
            checked: false,
          },
        ],
      },
    ],
  },
  {
    module: "Página Inicial",
    icon: IconHome,
    screens: [
      {
        name: "Página Inicial",
        options: [
          {
            name: "Gráfico",
            id: ACCESS.HOMEPAGE_graphic,
            checked: false,
          },
          {
            name: "Cards",
            id: ACCESS.HOMEPAGE_cards,
            checked: false,
          },
        ],
      },
    ],
  },
];
